function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ScriptingKeyOverlay = require('./scripting.js');
var FileUploadTemplate = require('./file-upload.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var SaitoNFT = require('./../../../../../lib/saito/ui/saito-nft/saito-nft');
var _require = require('../../transactions/add-file'),
  createVaultAddFileTransaction = _require.createVaultAddFileTransaction;
var DEFAULT_COPY = 'A standard Access Key provides access to the owner of the NFT. Transfer the NFT and ownership of the file transfers with it.';
var FileUpload = /*#__PURE__*/function () {
  function FileUpload(app, mod) {
    _classCallCheck(this, FileUpload);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.scripting_overlay = new ScriptingKeyOverlay(this.app, this.mod);
    this.nft_id = '';
    this.busy = false;
    this.onComplete = null;
    this.onError = null;
    this.library_mode = false;
  }
  return _createClass(FileUpload, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var opts,
          isMobile,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              opts = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              _context.n = 1;
              return this.ensureBalance();
            case 1:
              if (_context.v) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              isMobile = this.app.browser.isMobileBrowser() || typeof window !== 'undefined' && window.innerWidth <= 768;
              this.busy = false;
              this.onComplete = typeof opts.onComplete === 'function' ? opts.onComplete : null;
              this.onError = typeof opts.onError === 'function' ? opts.onError : null;
              this.library_mode = !!opts.library_mode || !!this.onComplete;
              this._completed = false;
              if (opts.file) {
                this.mod.file = opts.file;
              }
              if (opts.filename) {
                this.mod.filename = opts.filename;
              }
              this.overlay.show(FileUploadTemplate(this.app, this.mod, isMobile), function () {
                // User closed the overlay without a successful library handoff.
                if (_this.library_mode && !_this._completed && typeof _this.onError === 'function') {
                  try {
                    _this.onError(new Error('Vault upload cancelled'));
                  } catch (err) {}
                }
              });

              //
              // Prefill path (e.g. N-WASM library): skip file picker and open key step.
              //
              if (!(opts.prefilled && this.mod.file)) {
                _context.n = 3;
                break;
              }
              this.attachEvents(false);
              this.showKeyStep();
              return _context.a(2);
            case 3:
              this.attachEvents(isMobile);
            case 4:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "root",
    value: function root() {
      return document.querySelector('.vault-upload-overlay');
    }
  }, {
    key: "wait_for_paint",
    value: function () {
      var _wait_for_paint = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return new Promise(function (resolve) {
                requestAnimationFrame(function () {
                  requestAnimationFrame(resolve);
                });
              });
            case 1:
              _context2.n = 2;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 50);
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      function wait_for_paint() {
        return _wait_for_paint.apply(this, arguments);
      }
      return wait_for_paint;
    }()
  }, {
    key: "setKeyStepState",
    value: function setKeyStepState() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'idle';
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var root = this.root();
      if (!root) {
        return;
      }
      var keyStep = root.querySelector('.key-step');
      if (!keyStep) {
        return;
      }
      this.busy = mode === 'busy';
      keyStep.classList.toggle('is-uploading', mode === 'busy');
      keyStep.classList.toggle('is-success', mode === 'success');
      keyStep.classList.toggle('is-error', mode === 'error');
      var confirm = keyStep.querySelector('[data-action="confirm-key"]');
      var toggle = keyStep.querySelector('[data-action="toggle-mode"]');
      if (confirm) {
        confirm.disabled = mode === 'busy' || mode === 'success';
      }
      if (toggle) {
        toggle.setAttribute('aria-disabled', mode === 'busy' || mode === 'success' ? 'true' : 'false');
        toggle.style.pointerEvents = mode === 'busy' || mode === 'success' ? 'none' : '';
      }
      var state = keyStep.querySelector('.upload-state');
      var status = keyStep.querySelector('.upload-state .status');
      if (state) {
        state.hidden = mode === 'idle';
      }
      if (status && message) {
        status.textContent = message;
      }
    }
  }, {
    key: "showKeyStep",
    value: function showKeyStep() {
      var root = this.root();
      if (!root) {
        return;
      }
      var keyStep = root.querySelector('.key-step');
      var uploadStep = root.querySelector('.saito-file-drop-zone-wrap');
      if (keyStep) {
        keyStep.style.display = 'flex';
        this.setKeyStepState('idle');
      }
      if (uploadStep) {
        uploadStep.style.display = 'none';
      }
      this.applyMode();
    }
  }, {
    key: "applyMode",
    value: function applyMode() {
      var root = this.root();
      if (!root) {
        return;
      }
      var title = root.querySelector('.saito-overlay-form-header .saito-overlay-form-header-title');
      if (title) {
        title.textContent = 'STANDARD KEY';
      }
      var copy = root.querySelector('[data-key-copy]');
      if (copy) {
        copy.textContent = DEFAULT_COPY;
      }
      var artwork = root.querySelector('.key-artwork');
      if (artwork) {
        artwork.classList.add('jade');
        artwork.classList.remove('crystal');
      }
    }
  }, {
    key: "ensureBalance",
    value: function () {
      var _ensureBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var wallet_balance;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.app.wallet.getBalance('SAITO');
            case 1:
              wallet_balance = _context3.v;
              if (!(wallet_balance === 0n)) {
                _context3.n = 2;
                break;
              }
              siteMessage('Insufficient SAITO to Create Vault NFTs...', 3000);
              this.app.connection.emit('saito-purchase-launch');
              return _context3.a(2, false);
            case 2:
              return _context3.a(2, true);
          }
        }, _callee3, this);
      }));
      function ensureBalance() {
        return _ensureBalance.apply(this, arguments);
      }
      return ensureBalance;
    }()
  }, {
    key: "showStandardKeyStep",
    value: function showStandardKeyStep() {
      this.overlay.show(FileUploadTemplate(this.app, this.mod, false));
      this.attachEvents(false);
      this.showKeyStep();
    }
  }, {
    key: "openScriptingFlow",
    value: function openScriptingFlow() {
      var _this2 = this;
      this.overlay.hide();
      this.scripting_overlay.render();
      this.scripting_overlay.onReturnToDefault = function () {
        _this2.showStandardKeyStep();
      };
      this.scripting_overlay.callback = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(obj) {
          var _t;
          return _regenerator().w(function (_context4) {
            while (1) switch (_context4.p = _context4.n) {
              case 0:
                if (obj !== null && obj !== void 0 && obj.access_script) {
                  _context4.n = 1;
                  break;
                }
                return _context4.a(2);
              case 1:
                // Re-show key step busy state for the custom-key mint path.
                _this2.showStandardKeyStep();
                _this2.setKeyStepState('busy', 'Creating access key…');
                _context4.n = 2;
                return _this2.wait_for_paint();
              case 2:
                _context4.p = 2;
                _context4.n = 3;
                return _this2.mintNFT(obj.access_script, obj.nft_type || 'vault-nft-key');
              case 3:
                _context4.n = 5;
                break;
              case 4:
                _context4.p = 4;
                _t = _context4.v;
                console.error('Vault advanced CREATE KEY error:', _t);
                _this2.setKeyStepState('error', (_t === null || _t === void 0 ? void 0 : _t.message) || 'Unable to create Vault key. Please try again.');
              case 5:
                return _context4.a(2);
            }
          }, _callee4, null, [[2, 4]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this,
        _root$querySelector,
        _root$querySelector2;
      var openFilePicker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var root = this.root();
      if (!root) {
        return;
      }
      var keyStep = root.querySelector('.key-step');
      var uploadStep = root.querySelector('.saito-file-drop-zone-wrap');
      if (keyStep) {
        keyStep.style.display = 'none';
      }
      if (uploadStep) {
        uploadStep.style.display = 'flex';
      }
      this.app.browser.addDragAndDropFileUploadToElement('vault-file-upload', /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(file) {
          var confirm,
            fileobj,
            _args5 = arguments,
            _t2;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.p = _context5.n) {
              case 0:
                confirm = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : false;
                fileobj = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : null;
                _context5.p = 1;
                if (!(!file && fileobj)) {
                  _context5.n = 2;
                  break;
                }
                if (fileobj.size > _this3.app.browser.MAX_FILE_SIZE) {
                  salert("File size exceeds browser limit. Please choose a smaller file.");
                } else {
                  salert("Failed to read file. File may be too large (".concat((fileobj.size / 1024 / 1024).toFixed(2), " MB). Try a smaller file."));
                }
                return _context5.a(2);
              case 2:
                if (!(fileobj && fileobj.size > _this3.app.browser.MAX_FILE_SIZE)) {
                  _context5.n = 3;
                  break;
                }
                salert("File size exceeds browser limit. Please choose a smaller file.");
                return _context5.a(2);
              case 3:
                if (!(!file || !fileobj)) {
                  _context5.n = 4;
                  break;
                }
                salert('Invalid file. Please try again.');
                return _context5.a(2);
              case 4:
                _this3.mod.file = file;
                _this3.mod.filename = fileobj.name;
                _this3.showKeyStep();
                _context5.n = 6;
                break;
              case 5:
                _context5.p = 5;
                _t2 = _context5.v;
                console.error('Vault file upload error:', _t2);
                salert('Error processing file. Please try again.');
              case 6:
                return _context5.a(2);
            }
          }, _callee5, null, [[1, 5]]);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }(), true);
      if (openFilePicker) {
        var _document$querySelect;
        (_document$querySelect = document.querySelector('#hidden_file_element_vault-file-upload')) === null || _document$querySelect === void 0 || _document$querySelect.click();
      }
      (_root$querySelector = root.querySelector('[data-action="toggle-mode"]')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function (e) {
        e.preventDefault();
        if (_this3.busy) {
          return;
        }
        _this3.openScriptingFlow();
      });
      (_root$querySelector2 = root.querySelector('[data-action="confirm-key"]')) === null || _root$querySelector2 === void 0 || _root$querySelector2.addEventListener('click', /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(e) {
          var _t3;
          return _regenerator().w(function (_context6) {
            while (1) switch (_context6.p = _context6.n) {
              case 0:
                e.preventDefault();
                if (!_this3.busy) {
                  _context6.n = 1;
                  break;
                }
                return _context6.a(2);
              case 1:
                _context6.n = 2;
                return _this3.ensureBalance();
              case 2:
                if (_context6.v) {
                  _context6.n = 3;
                  break;
                }
                return _context6.a(2);
              case 3:
                // Immediate feedback before any mint/sign/upload work.
                _this3.setKeyStepState('busy', 'Creating access key…');
                _context6.n = 4;
                return _this3.wait_for_paint();
              case 4:
                _context6.p = 4;
                _context6.n = 5;
                return _this3.mintNFT();
              case 5:
                _context6.n = 7;
                break;
              case 6:
                _context6.p = 6;
                _t3 = _context6.v;
                console.error('Vault CREATE KEY error:', _t3);
                // Stay on this overlay with a recoverable error — do not fail the
                // library promise yet so the user can retry CREATE KEY.
                _this3.setKeyStepState('error', (_t3 === null || _t3 === void 0 ? void 0 : _t3.message) || 'Unable to create Vault key. Please try again.');
              case 7:
                return _context6.a(2);
            }
          }, _callee6, null, [[4, 6]]);
        }));
        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "mintNFT",
    value: function () {
      var _mintNFT = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this4 = this;
        var access_script,
          nft_type,
          depositAmt,
          balance,
          txmsg,
          nft_tx,
          nft_obj,
          file_tx,
          msg,
          monitorCopy,
          _args7 = arguments,
          _t4;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              access_script = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : null;
              nft_type = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : 'vault-nft-key';
              if (this.mod.file) {
                _context7.n = 1;
                break;
              }
              throw new Error('Please upload a file before creating an NFT.');
            case 1:
              depositAmt = BigInt(this.app.wallet.convertSaitoToNolan(1));
              _context7.n = 2;
              return this.app.wallet.getBalance();
            case 2:
              balance = _context7.v;
              if (!(balance < depositAmt)) {
                _context7.n = 3;
                break;
              }
              throw new Error('Insufficient funds to mint NFT');
            case 3:
              this.setKeyStepState('busy', 'Minting Vault key…');
              _context7.n = 4;
              return this.wait_for_paint();
            case 4:
              txmsg = {
                module: 'Vault',
                request: 'mint-vault-key',
                data: {
                  link: 'https://saito.io/vault',
                  filename: this.mod.filename,
                  file_id: ''
                }
              };
              _context7.n = 5;
              return this.app.wallet.createMintNFTTransaction(BigInt(1), depositAmt, txmsg, BigInt(0n), this.app.wallet.publicKey, nft_type);
            case 5:
              nft_tx = _context7.v;
              nft_obj = new SaitoNFT(this.app, this.mod, nft_tx);
              this.nft_id = nft_obj.id;
              if (this.nft_id) {
                _context7.n = 6;
                break;
              }
              throw new Error('Unable to compute NFT ID for minted NFT');
            case 6:
              this.setKeyStepState('busy', 'Binding access key to file…');
              _context7.n = 7;
              return this.wait_for_paint();
            case 7:
              _context7.n = 8;
              return createVaultAddFileTransaction(this.app, this.mod, this.nft_id, access_script);
            case 8:
              file_tx = _context7.v;
              if (file_tx) {
                _context7.n = 9;
                break;
              }
              throw new Error('Error creating Vault file transaction');
            case 9:
              // Hydrate msg from on-chain data before patching — nft_tx.msg defaults to {}
              // and sign()/packData() would otherwise overwrite data without link/module/etc.
              msg = nft_tx.returnMessage() || {};
              if (!msg.data || _typeof(msg.data) !== 'object') {
                msg.data = {};
              }
              msg.data.file_id = file_tx.signature;
              msg.data.filename = this.mod.filename;
              if (access_script != null) {
                msg.data.file_access_script = access_script;
              }
              nft_tx.msg = msg;
              this.setKeyStepState('busy', 'Signing and broadcasting…');
              _context7.n = 10;
              return this.wait_for_paint();
            case 10:
              _context7.n = 11;
              return nft_tx.sign();
            case 11:
              _context7.n = 12;
              return this.app.network.propagateTransaction(nft_tx);
            case 12:
              _context7.p = 12;
              _context7.n = 13;
              return this.app.storage.saveTransaction(nft_tx, {
                field1: 'Vault'
              }, 'localhost');
            case 13:
              _context7.n = 15;
              break;
            case 14:
              _context7.p = 14;
              _t4 = _context7.v;
              console.warn('Vault: unable to persist mint tx locally:', _t4);
            case 15:
              if (this.mod.peer) {
                _context7.n = 16;
                break;
              }
              throw new Error('ERROR: issue connecting to server. Please try again later.');
            case 16:
              this.setKeyStepState('busy', 'Uploading file to Vault…');
              _context7.n = 17;
              return this.wait_for_paint();
            case 17:
              _context7.n = 18;
              return new Promise(function (resolve, reject) {
                try {
                  var _this4$mod$peer;
                  _this4.app.network.sendRequestAsTransaction('vault add file', file_tx.serialize_to_web(_this4.app), function (res) {
                    if (res !== null && res !== void 0 && res.err) {
                      reject(res.err instanceof Error ? res.err : new Error(String(res.err)));
                      return;
                    }
                    resolve(res);
                  }, (_this4$mod$peer = _this4.mod.peer) === null || _this4$mod$peer === void 0 ? void 0 : _this4$mod$peer.publicKey);
                } catch (err) {
                  reject(err);
                }
              });
            case 18:
              //
              // Do not cache Access Key metadata here. Mint-time slip/utxo keys are not
              // authoritative until the mint tx is confirmed and visible in wallet.nfts.
              // Cache happens in cacheConfirmedAccessKey() after the transaction monitor.
              //

              this.setKeyStepState('success', 'Upload complete. Waiting for network confirmation…');
              _context7.n = 19;
              return this.wait_for_paint();
            case 19:
              siteMessage('File Upload Successful..', 3000);
              if (this.mod.transaction_monitor) {
                _context7.n = 20;
                break;
              }
              throw new Error('Vault: transaction_monitor is not initialized');
            case 20:
              monitorCopy = nft_type === 'vault-nft-rental' ? {
                title: 'Creating Rental Master Key',
                lead: 'Your Rental Master Key is being created on the Saito network.',
                subtitle: '',
                successTitle: 'Rental Master Key Created',
                successLead: 'Your Rental Master Key is now in your wallet.',
                successActionLabel: 'Continue'
              } : nft_type === 'vault-nft-key' && access_script ? {
                title: 'Creating Custom Access Key',
                lead: 'Your Custom Access Key is being created on the Saito network.',
                subtitle: '',
                successTitle: 'Custom Access Key Received',
                successLead: 'Your Custom Access Key is now in your wallet.',
                successActionLabel: 'Continue'
              } : {
                title: 'Creating Vault Access Key',
                lead: 'Your Vault Access Key NFT has been broadcast to the Saito network.',
                subtitle: '',
                successTitle: 'Vault Access Key Received',
                successLead: 'Your Vault Access Key has arrived.',
                successActionLabel: 'Continue'
              }; //
              // Library mode: wait for mint confirmation, cache confirmed metadata, then
              // hand control back so N-WASM can refresh its library. Standalone Vault
              // keeps the My NFTs path after the same confirmed cache write.
              //
              if (!this.library_mode) {
                _context7.n = 22;
                break;
              }
              _context7.n = 21;
              return new Promise(function (resolve) {
                _this4.mod.transaction_monitor.render(_objectSpread(_objectSpread({
                  tx: nft_tx
                }, monitorCopy), {}, {
                  auto_continue_on_confirm: true,
                  callback: function callback(result) {
                    _this4.busy = false;
                    if ((result === null || result === void 0 ? void 0 : result.status) === 'confirmed') {
                      _this4._completed = true;
                      _this4.overlay.hide();
                      _this4.cacheConfirmedAccessKey(nft_tx, file_tx, access_script, result).then(function (meta) {
                        if (typeof _this4.onComplete === 'function') {
                          try {
                            _this4.onComplete({
                              status: 'confirmed',
                              nft_tx: nft_tx,
                              nft_id: (meta === null || meta === void 0 ? void 0 : meta.nft_id) || _this4.nft_id,
                              file_id: (meta === null || meta === void 0 ? void 0 : meta.file_id) || file_tx.signature,
                              filename: (meta === null || meta === void 0 ? void 0 : meta.filename) || _this4.mod.filename
                            });
                          } catch (err) {
                            console.error('Vault onComplete error:', err);
                          }
                        }
                        resolve(result);
                      })["catch"](function (err) {
                        console.error('Vault confirmed Access Key cache error:', err);
                        if (typeof _this4.onError === 'function') {
                          try {
                            _this4.onError(err instanceof Error ? err : new Error(String(err || 'Vault cache failed')));
                          } catch (e) {}
                        }
                        resolve(result);
                      });
                      return;
                    }

                    // User dismissed the monitor before confirmation — treat as cancel.
                    _this4._completed = true;
                    _this4.overlay.hide();
                    if (typeof _this4.onError === 'function') {
                      try {
                        _this4.onError(new Error('Vault upload cancelled before confirmation'));
                      } catch (err) {}
                    }
                    resolve(result);
                  }
                }));
              });
            case 21:
              return _context7.a(2);
            case 22:
              this.overlay.hide();
              this.busy = false;
              this.mod.transaction_monitor.render(_objectSpread(_objectSpread({
                tx: nft_tx
              }, monitorCopy), {}, {
                callback: function callback(result) {
                  if ((result === null || result === void 0 ? void 0 : result.status) === 'confirmed') {
                    _this4.cacheConfirmedAccessKey(nft_tx, file_tx, access_script, result)["catch"](function (err) {
                      console.warn('Vault: confirmed Access Key cache failed:', err);
                    })["finally"](function () {
                      _this4.app.connection.emit('vault-file-access-render');
                    });
                  }
                }
              }));
            case 23:
              return _context7.a(2);
          }
        }, _callee7, this, [[12, 14]]);
      }));
      function mintNFT() {
        return _mintNFT.apply(this, arguments);
      }
      return mintNFT;
    }() //
    // After mint confirmation: refresh wallet NFT slips and write/replace the
    // single Vault NFT→file cache entry used by Vault download and N-WASM.
    //
    /**
     * After mint confirmation, collect Access Key fields from the mint tx +
     * wallet slips for onComplete / My NFTs. Does not write a cross-module cache.
     */
  }, {
    key: "cacheConfirmedAccessKey",
    value: function () {
      var _cacheConfirmedAccessKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(nft_tx, file_tx) {
        var _msg, _this$app$options, _nft_entry$slip, _nft_entry$slip2, _nft_entry$slip3;
        var access_script,
          confirmed,
          tx,
          msg,
          _tx$returnMessage,
          _nft_tx$returnMessage,
          data,
          tx_sig,
          nft_id,
          nfts,
          nft_entry,
          slip1_utxokey,
          slip2_utxokey,
          slip3_utxokey,
          _nft$slip,
          _nft$slip2,
          _nft$slip3,
          nft,
          file_id,
          _args8 = arguments,
          _t5;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              access_script = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : null;
              confirmed = _args8.length > 3 && _args8[3] !== undefined ? _args8[3] : null;
              tx = (confirmed === null || confirmed === void 0 ? void 0 : confirmed.tx) || nft_tx;
              msg = {};
              try {
                msg = (tx === null || tx === void 0 || (_tx$returnMessage = tx.returnMessage) === null || _tx$returnMessage === void 0 ? void 0 : _tx$returnMessage.call(tx)) || (nft_tx === null || nft_tx === void 0 || (_nft_tx$returnMessage = nft_tx.returnMessage) === null || _nft_tx$returnMessage === void 0 ? void 0 : _nft_tx$returnMessage.call(nft_tx)) || (nft_tx === null || nft_tx === void 0 ? void 0 : nft_tx.msg) || {};
              } catch (err) {
                msg = (nft_tx === null || nft_tx === void 0 ? void 0 : nft_tx.msg) || {};
              }
              data = (_msg = msg) !== null && _msg !== void 0 && _msg.data && _typeof(msg.data) === 'object' ? msg.data : {};
              _context8.p = 1;
              _context8.n = 2;
              return this.app.wallet.updateNFTList();
            case 2:
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t5 = _context8.v;
              console.warn('Vault: updateNFTList after Access Key confirmation failed:', _t5);
            case 4:
              tx_sig = (nft_tx === null || nft_tx === void 0 ? void 0 : nft_tx.signature) || (tx === null || tx === void 0 ? void 0 : tx.signature) || '';
              nft_id = this.nft_id || '';
              nfts = ((_this$app$options = this.app.options) === null || _this$app$options === void 0 || (_this$app$options = _this$app$options.wallet) === null || _this$app$options === void 0 ? void 0 : _this$app$options.nfts) || [];
              nft_entry = nfts.find(function (n) {
                return nft_id && n.id === nft_id || tx_sig && n.tx_sig === tx_sig;
              }) || null;
              slip1_utxokey = (nft_entry === null || nft_entry === void 0 || (_nft_entry$slip = nft_entry.slip1) === null || _nft_entry$slip === void 0 ? void 0 : _nft_entry$slip.utxo_key) || '';
              slip2_utxokey = (nft_entry === null || nft_entry === void 0 || (_nft_entry$slip2 = nft_entry.slip2) === null || _nft_entry$slip2 === void 0 ? void 0 : _nft_entry$slip2.utxo_key) || '';
              slip3_utxokey = (nft_entry === null || nft_entry === void 0 || (_nft_entry$slip3 = nft_entry.slip3) === null || _nft_entry$slip3 === void 0 ? void 0 : _nft_entry$slip3.utxo_key) || ''; // Wallet list is preferred; fall back to slips on the confirmed mint tx.
              if (!slip1_utxokey || !slip2_utxokey || !slip3_utxokey) {
                try {
                  nft = new SaitoNFT(this.app, this.mod, tx || nft_tx, nft_entry);
                  slip1_utxokey = slip1_utxokey || ((_nft$slip = nft.slip1) === null || _nft$slip === void 0 ? void 0 : _nft$slip.utxo_key) || '';
                  slip2_utxokey = slip2_utxokey || ((_nft$slip2 = nft.slip2) === null || _nft$slip2 === void 0 ? void 0 : _nft$slip2.utxo_key) || '';
                  slip3_utxokey = slip3_utxokey || ((_nft$slip3 = nft.slip3) === null || _nft$slip3 === void 0 ? void 0 : _nft$slip3.utxo_key) || '';
                  if (!this.nft_id && nft.id) {
                    this.nft_id = nft.id;
                  }
                } catch (err) {
                  console.warn('Vault: unable to derive slips from confirmed mint tx:', err);
                }
              }
              file_id = data.file_id || (file_tx === null || file_tx === void 0 ? void 0 : file_tx.signature) || '';
              if (file_id) {
                _context8.n = 5;
                break;
              }
              throw new Error('Confirmed Vault Access Key is missing file_id');
            case 5:
              return _context8.a(2, {
                nft_id: this.nft_id || (nft_entry === null || nft_entry === void 0 ? void 0 : nft_entry.id) || tx_sig,
                tx_sig: tx_sig,
                file_id: file_id,
                filename: data.filename || this.mod.filename || '',
                link: data.link || 'https://saito.io/vault',
                slip1_utxokey: slip1_utxokey,
                slip2_utxokey: slip2_utxokey,
                slip3_utxokey: slip3_utxokey,
                file_access_script: data.file_access_script || access_script || null
              });
          }
        }, _callee8, this, [[1, 3]]);
      }));
      function cacheConfirmedAccessKey(_x4, _x5) {
        return _cacheConfirmedAccessKey.apply(this, arguments);
      }
      return cacheConfirmedAccessKey;
    }()
  }]);
}();
module.exports = FileUpload;